import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Management App Firebase Config (existing)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Client Portal Firebase Config (for appointments sync)
const portalFirebaseConfig = {
  apiKey: process.env.REACT_APP_PORTAL_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_PORTAL_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PORTAL_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_PORTAL_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_PORTAL_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_PORTAL_FIREBASE_APP_ID,
};

// Fail loudly on missing config so we catch misconfiguration immediately
if (!firebaseConfig.apiKey) {
  throw new Error('Missing Firebase config. Check REACT_APP_FIREBASE_* env vars.');
}
if (!portalFirebaseConfig.apiKey) {
  throw new Error('Missing portal Firebase config. Check REACT_APP_PORTAL_FIREBASE_* env vars.');
}

// Initialize Management Firebase (primary)
const app = initializeApp(firebaseConfig);

// Initialize Portal Firebase (secondary) for appointments
const portalApp = initializeApp(portalFirebaseConfig, "portal");

// Initialize Firestore instances
export const db = getFirestore(app); // Management DB
export const portalDb = getFirestore(portalApp); // Portal DB

// Initialize Storage (from management app)
export const storage = getStorage(app);

// Enable offline persistence for both databases
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.log('Management DB: Multiple tabs open, persistence can only be enabled in one tab at a time.');
  } else if (err.code === 'unimplemented') {
    console.log('Management DB: The current browser doesn\'t support offline persistence');
  }
});

enableIndexedDbPersistence(portalDb).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.log('Portal DB: Multiple tabs open, persistence can only be enabled in one tab at a time.');
  } else if (err.code === 'unimplemented') {
    console.log('Portal DB: The current browser doesn\'t support offline persistence');
  }
});

export const auth = getAuth(app);
